import { z } from 'zod';
import { productDocumentSchema } from './products';

export const reviewDocumentSchema = z.object({
  id: z.string().optional(),
  comment: z.string().optional(),

  // Rating categories
  communication: z
    .literal('Bad')
    .or(z.literal('Good'))
    .or(z.literal('Excellent')),

  delivery_time: z
    .literal('Bad')
    .or(z.literal('Good'))
    .or(z.literal('Excellent'))
    .optional(), // Optional for buyer reviews (sellers reviewing buyers)

  payment: z
    .literal('Bad')
    .or(z.literal('Good'))
    .or(z.literal('Excellent'))
    .optional(), // For buyer reviews (how prompt was payment)

  is_anonymous: z.boolean().default(false),
  rating: z.number().min(1).max(5).default(5),
  created_at: z.number().optional(),
  order_id: z.string(),
  uid: z.string(),
  reviewer_id: z.string(),
  // subject_role indicates what role the person being reviewed had in the transaction:
  // 'seller' = this review is of the person AS A SELLER (buyer reviewed them)
  // 'buyer' = this review is of the person AS A BUYER (seller reviewed them)
  subject_role: z.enum(['buyer', 'seller']).optional(),
  // reviewer_role indicates the role of the person who wrote the review
  reviewer_role: z.enum(['buyer', 'seller']).optional(),
  subject_uid: z.string().optional(), // UID of the person being reviewed
  reveal_date: z.number().optional(), // Timestamp when blind period ends and review becomes visible
  products: z.array(productDocumentSchema).optional(), // Optional for buyer reviews
});

export type ReviewDocument = z.infer<typeof reviewDocumentSchema>;
